import { Select, styled } from '@mui/material';

export const CustomSelect = styled(Select)(({ theme }) => ({
	backgroundColor: theme.palette.primary.main,
	color: '#FFFFFF',
	border: '1px solid #FFFFFF59',
	borderRadius: '40px',
	fontSize: '14px',
	'& .MuiSelect-select': {
		padding: '4px 24px 4px 16px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		border: 'none',
	},
	'&:hover': {
		backgroundColor: theme.palette.primary.dark,
	},
	'& .MuiSvgIcon-root': {
		color: '#FFFFFF',
	},
}));
